var _rect, _circle, _circle2, _g, _g2, _g3, _g4, _g5, _g6, _path, _path2, _path3, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMyStoryLearning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 600,
    viewBox: "0 0 600 600",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 600,
    fill: "#f8f9fa",
    rx: 20,
    ry: 20
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 80,
    fill: "#e9ecef",
    opacity: 0.7
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 500,
    cy: 500,
    r: 80,
    fill: "#e9ecef",
    opacity: 0.7
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(300, 400) scale(1.2)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -120,
    y: -30,
    width: 240,
    height: 40,
    rx: 5,
    ry: 5,
    fill: "#4361ee",
    stroke: "#2b4acb",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: -110,
    y: -30,
    width: 220,
    height: 5,
    rx: 2,
    ry: 2,
    fill: "#2b4acb"
  }), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: -5,
    fontFamily: "Arial",
    fontSize: 16,
    fill: "white",
    textAnchor: "middle"
  }, "Oromo Language"), /*#__PURE__*/React.createElement("rect", {
    x: -110,
    y: -60,
    width: 220,
    height: 30,
    rx: 5,
    ry: 5,
    fill: "#3a86ff",
    stroke: "#2a66cf",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: -100,
    y: -60,
    width: 200,
    height: 5,
    rx: 2,
    ry: 2,
    fill: "#2a66cf"
  }), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: -40,
    fontFamily: "Arial",
    fontSize: 14,
    fill: "white",
    textAnchor: "middle"
  }, "Grammar"), /*#__PURE__*/React.createElement("rect", {
    x: -130,
    y: -85,
    width: 200,
    height: 25,
    rx: 5,
    ry: 5,
    fill: "#4cc9f0",
    stroke: "#2a9ec0",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: -120,
    y: -85,
    width: 180,
    height: 5,
    rx: 2,
    ry: 2,
    fill: "#2a9ec0"
  }), /*#__PURE__*/React.createElement("text", {
    x: -30,
    y: -70,
    fontFamily: "Arial",
    fontSize: 12,
    fill: "white",
    textAnchor: "middle"
  }, "Vocabulary"), /*#__PURE__*/React.createElement("rect", {
    x: -100,
    y: -105,
    width: 180,
    height: 20,
    rx: 5,
    ry: 5,
    fill: "#f72585",
    stroke: "#c01a69",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: -90,
    y: -105,
    width: 160,
    height: 4,
    rx: 2,
    ry: 2,
    fill: "#c01a69"
  }), /*#__PURE__*/React.createElement("text", {
    x: -10,
    y: -92,
    fontFamily: "Arial",
    fontSize: 10,
    fill: "white",
    textAnchor: "middle"
  }, "Culture"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(300, 250)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: -70,
    r: 40,
    fill: "#ffb703",
    stroke: "#333",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -15,
    cy: -75,
    r: 5,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: -75,
    r: 5,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-10,-55 Q0,-45 10,-55",
    stroke: "#333",
    strokeWidth: 3,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,-30 L0,50",
    stroke: "#333",
    strokeWidth: 8,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L-60,-20",
    stroke: "#333",
    strokeWidth: 6,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-60,-20 L-90,10",
    stroke: "#333",
    strokeWidth: 6,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L60,-30",
    stroke: "#333",
    strokeWidth: 6,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,-30 L100,-10",
    stroke: "#333",
    strokeWidth: 6,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,50 L-30,120",
    stroke: "#333",
    strokeWidth: 8,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,50 L30,120",
    stroke: "#333",
    strokeWidth: 8,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -90,
    y: 10,
    width: 60,
    height: 40,
    rx: 5,
    ry: 5,
    fill: "#fb8500",
    stroke: "#333",
    strokeWidth: 2,
    transform: "rotate(-10)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -85,
    y: 20,
    width: 50,
    height: 5,
    fill: "#333",
    transform: "rotate(-10)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -85,
    y: 30,
    width: 50,
    height: 5,
    fill: "#333",
    transform: "rotate(-10)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -85,
    y: 40,
    width: 30,
    height: 5,
    fill: "#333",
    transform: "rotate(-10)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(180, 100)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 30,
    fill: "white",
    stroke: "#333",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 5,
    fontFamily: "Arial",
    fontSize: 20,
    fill: "#333",
    textAnchor: "middle"
  }, "\u12A0"))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(250, 70)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 25,
    fill: "white",
    stroke: "#333",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 5,
    fontFamily: "Arial",
    fontSize: 18,
    fill: "#333",
    textAnchor: "middle"
  }, "\u1265"))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(320, 50)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 35,
    fill: "white",
    stroke: "#333",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 5,
    fontFamily: "Arial",
    fontSize: 22,
    fill: "#333",
    textAnchor: "middle"
  }, "\u1203"))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(400, 80)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 28,
    fill: "white",
    stroke: "#333",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 5,
    fontFamily: "Arial",
    fontSize: 19,
    fill: "#333",
    textAnchor: "middle"
  }, "\u1230"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M190,120 L230,90",
    stroke: "#333",
    strokeWidth: 2,
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M270,80 L300,65",
    stroke: "#333",
    strokeWidth: 2,
    fill: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M350,60 L380,70",
    stroke: "#333",
    strokeWidth: 2,
    fill: "none"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 300,
    y: 550,
    fontFamily: "Arial",
    fontWeight: "bold",
    fontSize: 24,
    fill: "#333",
    textAnchor: "middle"
  }, "Learning Oromo")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyStoryLearning);
export default __webpack_public_path__ + "static/media/my-story-learning.bee11d567b64bb62f3dad06820246af8.svg";
export { ForwardRef as ReactComponent };